import type { ProductCard } from "../types";

export const products: ProductCard[] = [
  {
    id: 'beyond-sandbox',
    name: 'Beyond Sandbox',
    tagline: 'Go to market faster with a sandbox that understands regulation.',
    description: 'Test and validate your solution against actual regulatory requirements. Our sandbox environment simulates real-world regulatory reporting and monitoring across multiple jurisdictions. Catch issues in dev, not in production.',
    buttonText: 'Explore Sandbox APIs',
    status: 'active'
  },
  {
    id: 'beyond-compliance',
    name: 'Beyond Compliance',
    tagline: 'Automate regulatory reporting and monitoring.',
    description: 'Focus on your product, not on spreadsheets. Integrate our APIs to automate your compliance workflows. Get real-time monitoring, streamlined reporting, and a centralized hub for tracking regulatory obligations across all your services.',
    buttonText: 'View Product Details',
    status: 'active'
  },
  {
    id: 'beyond-cash',
    name: 'Beyond Cash',
    tagline: 'Coming Soon',
    description: 'Build on our Web3 digital cash infrastructure.',
    buttonText: 'View Product Details',
    status: 'coming-soon'
  }
];
